/**
 * Release Dawn's scroll lock when the Orbe geolocation modal closes.
 *
 * The shipping-country button in the mobile nav drawer (snippets/header-drawer.liquid)
 * opens Orbe's country modal. Opening that drawer put `overflow-hidden-<breakpoint>`
 * on <body> (HeaderDrawer.openMenuDrawer, assets/global.js), but closing Orbe's modal
 * never runs Dawn's closeMenuDrawer — so the class is stranded and the page cannot be
 * scrolled on mobile/tablet until a reload.
 *
 * Orbe keeps `.md-app-embed` as a permanent child of <body> and shows/hides it by
 * toggling `orbe--hidden`; the modal is never inserted or removed. So the authoritative
 * signal is that class flipping back on, with the close button handled directly as the
 * common case. Both paths are guarded and idempotent.
 *
 * Loaded from sections/header.liquid, which is where the lock originates.
 * Verified against orbe-geolocation-499 on 2026-09-17.
 */
(function () {
  var ROOT_SELECTOR = '.md-app-embed';
  var HIDDEN_CLASS = 'orbe--hidden';
  var CLOSE_SELECTOR = '.md-modal-closeButton';

  /**
   * The exact class HeaderDrawer added, read off the element rather than hardcoded —
   * it is `desktop` when menu_type_desktop is 'drawer', else `tablet`. Plain
   * `overflow-hidden` covers the cart drawer and search modal, in case the Orbe modal
   * was opened over one of those instead.
   */
  function lockClasses() {
    var drawer = document.querySelector('header-drawer');
    var breakpoint = (drawer && drawer.dataset.breakpoint) || 'tablet';
    return ['overflow-hidden-' + breakpoint, 'overflow-hidden'];
  }

  /** Something in the theme still legitimately owns the lock — leave it alone. */
  function themeOwnsScrollLock() {
    return Boolean(
      document.querySelector('header-drawer details[open]') ||
        document.querySelector('menu-drawer details[open]') ||
        document.querySelector('cart-drawer.active') ||
        document.querySelector('details-modal details[open]')
    );
  }

  function releaseScrollLock() {
    if (themeOwnsScrollLock()) return;

    lockClasses().forEach(function (className) {
      document.body.classList.remove(className);
    });

    // The drawer's focus trap outlives the drawer if Dawn's close path never ran,
    // which would strand keyboard focus inside hidden markup.
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }

  function isHidden(root) {
    return root.classList.contains(HIDDEN_CLASS) || getComputedStyle(root).display === 'none';
  }

  // Primary path: the modal's own close button. Deferred a frame so Orbe's handler
  // finishes before we read the DOM.
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest(CLOSE_SELECTOR)) return;
    requestAnimationFrame(releaseScrollLock);
  });

  // Safety net: dismissals that never touch the close button (backdrop, Escape, or a
  // country being chosen). Watches the visibility class rather than insertion.
  function watch(root) {
    var wasHidden = isHidden(root);

    new MutationObserver(function () {
      var nowHidden = isHidden(root);
      if (!wasHidden && nowHidden) releaseScrollLock();
      wasHidden = nowHidden;
    }).observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  // Orbe's bundle is async, so the root may not exist yet.
  var existing = document.querySelector(ROOT_SELECTOR);

  if (existing) {
    watch(existing);
  } else {
    var waiting = new MutationObserver(function () {
      var root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;
      waiting.disconnect();
      watch(root);
    });

    waiting.observe(document.body, { childList: true });
  }
})();
